import React, { useState } from "react";
import { LayerItemAttribute } from "../../services/types";
import { parseMarkdown } from "../../utils/helpers";

interface ConstructionAttributeTableProps {
    attributes: LayerItemAttribute[];
};

const ConstructionAttributeTable = ({ attributes }: ConstructionAttributeTableProps) => {
    const [expandedRows, setExpandedRows] = useState<Record<number, boolean>>({});

    const handleClick = (index: number) => {
        setExpandedRows((prev) => ({
            ...prev,
            [index]: !prev[index],
        }));
    };

    // Filter out attributes that don't have values
    const validAttributes = attributes.filter(attribute => attribute.value && attribute.name !== 'Crash Impact Statement');

    return (
        <div className="overflow-hidden rounded-lg border border-gray-300 shadow-md">
            <table className="w-full border-collapse">
                <tbody>
                    {validAttributes.map((attribute, index) => (
                        <React.Fragment key={attribute.name}>
                            {/* Attribute Name Row */}
                            <tr className="bg-gray-100">
                                <td className="px-4 py-2 text-xs font-bold text-gray-800">{attribute.name}</td>
                            </tr>
                            
                            {/* Attribute Value Row */}
                            <tr className="odd:bg-white even:bg-gray-50">
                                <td className="px-4 py-1 text-xs text-gray-800">
                                    <div
                                        className={`${
                                            !expandedRows[index] ? "line-clamp-1" : "line-clamp-none"
                                        }`}
                                        dangerouslySetInnerHTML={{ __html: parseMarkdown(attribute.value) }}
                                    ></div>
                                    {index !== 0 && (
                                        <span
                                            className="text-blue-500 cursor-pointer hover:underline"
                                            onClick={() => handleClick(index)}
                                        >
                                            {expandedRows[index] ? "Show Less" : "Show More"}
                                        </span>
                                    )}
                                </td>
                            </tr>
                        </React.Fragment>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default ConstructionAttributeTable;